import { PRINT_NULL } from '../constants';

// eslint-disable-next-line
export const formatToDollarFT = (value: any) => {
  if (value === null) {
    return PRINT_NULL;
  }
  return `${value} $/ft`;
};
